module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", [_vm._v("\n                        Přejete si uložit změny a odsouhlasit novou cenu pro další krmivo?\n                    ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "old-price"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Původní cena:")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.oldPrice))]), _vm._v(" "), _c('span', {
    staticClass: "currency"
  }, [_vm._v("Kč")])]), _vm._v(" "), _c('div', {
    staticClass: "new-price"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Nová cena:")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.newPrice))]), _vm._v(" "), _c('span', {
    staticClass: "currency"
  }, [_vm._v("Kč")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [_c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n                            Ne\n                        ")]), _vm._v(" "), _c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": _vm.confirmCallback
    }
  }, [_vm._v("\n                            Ano\n                        ")])])], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-907c00bc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConfirmationModal.vue
// module id = 578
// module chunks = 1